import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Wrapper } from "modules/theme";
import { Alert, confirm } from "modules/theme";
import APIManager from "modules/common/apiManager";
import { Row, RowTitle, Box, BoxName, Divider } from "../../main/styles";
import { BarItems } from "modules/theme";
import {
  DataWrapperClass,
  SectionHead,
  SectionTitle,
  TagsStyle,
} from "../styles";
import { Modal } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";
import { PerPage } from "helpers/system-config";
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  ActionButtons,
  Table,
  Label,
  Tip,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  ReportPagination,
  SeachForm,
} from "modules/theme";
import TagAddEdit from "./TagAddEdit";
import TagsSidebar from "../sidebar";
import { SidebarList } from "modules/theme";
import { modalType } from "../../../../../helpers/dotenv";
import { MdOutlineAdd } from "react-icons/md";

class Tag extends Component {
  constructor(props) {
    super(props);
    this.moduleName = `Tag`;
    this.moduleUrl = `setting-tag`;

    this.mAPI = new APIManager();
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      showHide: false,
      moduleNameList: [],
      modalType: modalType,
      currentModule: {},
      moduleId: props.moduleId || "",
      SelectedList: [],
      ary: [],
      search: "",
    };
    // this.getModuleName();
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map((listData) => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    //To Control Master Checkbox State
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;
    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  // search(e) {
  //   let value;
  //   value = e.target.value;
  //   if (this.timer) clearTimeout(this.timer);
  //   this.timer = setTimeout(() => {
  //     this.setState({ search: value });
  //     this.getTag(1, '', this.state.moduleId, this.state.search);
  //   }, 500);
  // }

  search(e) {
    let teamList = this.state.listData;
    teamList.map((e) => (e.selected = false));
    this.setState({
      SelectedList: [],
      MasterChecked: false,
      SingleChecked: false,
      listData: teamList,
      currentPage: 1
    });
    let value;
    value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ search: value });
        this.getTag(1, this.state.perPageCount, value);
      }, 500);
    }
  }

  componentDidMount() {
    // if (this.state.moduleId) {
    //   this.getTag(
    //     this.state.currentPage,
    //     this.state.perPageCount,
    //     this.state.moduleId
    //   );
    // }
    this.getTag();
  }

  getModuleName() {
    var that = this;
    // this.setState({ loading: true });
    this.mAPI.sendGetAPI(
      `setting/tag/module-name`,
      (data) => {
        if (data && data.names) {
          that.setState({ moduleNameList: data.names });
          if (that.state.moduleId == "") {
            let modules = Object.entries(data.names);
            if (modules && modules[0] && modules[0][1]) {
              this.getTag(1, this.state.perPageCount, modules[0][1]);
              that.setState({ moduleId: modules[0][1] });
            }
          }
        } else {
          that.setState({ moduleNameList: [] });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        // if (data) {
        //   Alert.success(`${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }

  getTag(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    // if (moduleId != '') {
    this.mAPI.sendGetAPI(
      `setting/tag?limit=${perPage}&page_no=${page}&search=${searchText}&orderBy=create_at&order=DESC`,
      (data) => {
        this.setState({ loading: false });
        console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({
            listData: data.data,
            total: data.count || 0,
            SelectedList: [],
            ary: [],
          });
        } else {
          that.setState({ listData: [] });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        // if (data) {
        //   Alert.success(`${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
    // } else {
    //   that.setState({ loading: false, listData: [], total: 0 });
    // }
  }

  // onPaginationChange(page) {
  //   console.log('onPaginationChange', page);
  //   this.setState({ currentPage: page });
  //   this.getTag(page, this.state.perPageCount, this.state.search, this.state.moduleId);
  // }

  // onPerPageChooser(perPage) {
  //   console.log('onPerPageChooser', perPage);
  //   this.setState({ currentPage: 1 });
  //   this.setState({ perPageCount: perPage });
  //   this.getTag(1, perPage, this.state.moduleId);
  // }

  onPaginationChange(page) {
    console.log("onPaginationChange", page);
    this.setState({ currentPage: page });
    this.getTag(page, "", this.state.search);
  }

  onPerPageChooser(perPage) {
    console.log("onPerPageChooser", perPage);
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getTag(1, perPage, this.state.search);
  }

  // closeModal(isUpdated) {
  //   console.log('isUpdated', isUpdated);
  //   this.setState({ showHide: false });
  //   if (isUpdated && this.state.moduleId) {
  //     // this.state.currentPage, this.state.perPageCount, this.state.moduleId;
  //     this.getTag(1, this.state.perPageCount, this.state.moduleId);
  //   }
  // }

  closeModal(isUpdated) {
    console.log("isUpdated", isUpdated);
    this.setState({ showHide: false });
    if (isUpdated) {
      this.getTag(this.state.currentPage, this.state.perPageCount, this.state.search);
    }
  }

  openModal(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  deleteTag(tTag) {
    var that = this;
    this.mAPI.sendPostAPI(
      `setting/tag/${tTag._id}`,
      undefined,
      (data) => {
        console.log(JSON.stringify(data, null, 2));
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", tTag._id);
        that.setState({ listData: tD });
        this.getTag();
        this.getList();
        Alert.success(`Tag ${tTag.name} is deleted.`);
      },
      (errorCode, data) => {
        console.log(`Error: `, errorCode);
        console.log(`Data`, data);
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    // const ary = [];
    const list = this.state.SelectedList.map((data) => {
      // ary = data._id;
      this.state.ary.push(data._id);
      // this.setState({ ary: data._id });
      console.log("data deleteAllData in Tag", this.state.ary);
    });
    this.mAPI.sendPostAPI(
      `setting/tag/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        console.log(JSON.stringify(data, null, 2));
        this.getList();
        Alert.success(`${this.moduleName} is deleted.`);
      },
      (errorCode, data) => {
        console.log(`Error: `, errorCode);
        console.log(`Data`, data);
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  onChange() {}

  onSingleChange(e, company) {}

  editTag(tTag) {
    return (
      <Tip text={`${"Edit"}`} key={`${"Edit"}`}>
        <Button
          btnStyle="link"
          onClick={() => this.openModal(tTag)}
          style={{ verticalAlign: "middle" }}
          icon="edit"
        ></Button>
      </Tip>
    );
  }

  renderActions(data) {
    return (
      <ActionButtons>
        {this.editTag(data)}
        <Tip text={`${"delete"}`} key={`${"delete"}`}>
          <Button
            btnStyle="link"
            onClick={(e) =>
              confirm().then((e) => {
                this.deleteTag(data, e);
              })
            }
            style={{ verticalAlign: "middle" }}
            // icon={'user-minus'}
          >
            <FiTrash2 style={{ fontSize: "14px" }} />
          </Button>
        </Tip>
      </ActionButtons>
    );
  }

  renderActionBar() {
    const importTrigger = (
      <Button btnStyle="default" size="small">
        {/* <MdOutlineAdd /> */}
        <img src="/images/plus.png" style={{ width: "12px" }} />
      </Button>
    );
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        <SeachForm>
          <FormControl
            type="text"
            placeholder={"Search..."}
            onChange={(e) => this.search(e)}
            value={this.state.searchValue}
            autoFocus={false}
          />
        </SeachForm>
        {/* <FormControl
          type="text"
          placeholder={'Type to search'}
          onChange={e => this.search(e)}
          value={this.state.searchValue}
          autoFocus
        /> */}
        <ModalTrigger
          title="Tag"
          trigger={importTrigger}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          // dialogClassName="right"
          dialogClassName={this.state.modalType}
        >
          <TagAddEdit
            update={() => this.setState({ currentPage: 1 })}
            size="small"
            isEdit={false}
            moduleNameList={this.state.moduleNameList}
            listData={this.state.listData}
            editData={this.state.editData}
            closeModal={this.closeModal}
            modalType={this.state.modalType}
            moduleId={this.state.moduleId}
          />
        </ModalTrigger>
      </span>
    );
  }

  handleModuleOnClick(e, carrier) {
    this.setState({
      currentModule: carrier,
    });
    console.log(this.state.currentModule);
  }

  renderModuleName() {
    return Object.entries(this.state.moduleNameList).map(([key, value]) => {
      return (
        <SectionHead key={value} value={key}>
          {/* {module.name} */}
          <SectionTitle
            className={value === this.state.moduleId ? "active" : ""}
            onClick={(e) => {
              this.handleModuleOnClick(e, value);
            }}
          >
            <Link
              to={`/settings/Tag?id=${value}`}
              style={{ textTransform: "capitalize" }}
              // to={{
              //   state: { contactId: module._id},
              //   pathname: ,
              //   search: `?id=${module._id}`,
              // }}
              onClick={() => {
                this.setState({ currentPage: 1, moduleId: value });
                this.getTag(1, this.state.perPageCount, value);
                console.log("contactId getList", value);
              }}
            >
              {`${value}`}
            </Link>
          </SectionTitle>
        </SectionHead>
      );
    });
  }

  render() {
    const { __ } = this.context;
    const { Section, Header } = Wrapper.Sidebar;
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
      { title: __("Tag"), link: "/settings/Tag" },
    ];

    const maduleList = (
      // <QuestionsContainer>
      <Wrapper.Sidebar>
        <Section>
          <Header uppercase>Tag</Header>
          <SidebarList activeClassName="active">
            {this.renderModuleName()}
          </SidebarList>
        </Section>
      </Wrapper.Sidebar>
      // </QuestionsContainer>
    );

    const mainContent = (
      <DataWrapperClass>
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              {/* <th>
                <FormControl
                  componentClass="checkbox"
                  checked={this.state.MasterChecked}
                  onChange={e => this.onMasterCheck(e)}
                // onChange={this.onChange}
                />
              </th> */}
              <th>{__("Name")}</th>
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody id="Tag">
            {this.state.listData.map((tTag) => (
              <tr key={tTag._id}>
                <td onClick={this.onClick}>
                  <FormControl
                    componentClass="checkbox"
                    checked={tTag.selected}
                    onChange={(e) => this.onItemCheck(e, tTag)}
                  />
                </td>
                <td className="text-primary">
                  <TagsStyle style={{ backgroundColor: tTag.colourCode }}>
                    {tTag.name}
                  </TagsStyle>
                </td>
                <td>{this.renderActions(tTag)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </DataWrapperClass>
    );

    return (
      <div>
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div>
                    <ControlLabel>{`Tag(${this.state.total ||
                      0})`}</ControlLabel>
                    {/* {console.log('masterchk', this.state.SelectedList)} */}
                    {this.state.SelectedList.length > 0 ? (
                      <Tip text={`${"Delete"}`} key={`${"Delete"}`}>
                        <Button
                          btnStyle="danger"
                          size="small"
                          onClick={(e) =>
                            confirm().then((e) => {
                              this.deleteAllData(e);
                            })
                          }
                          style={{
                            verticalAlign: "middle",
                            marginLeft: "10px",
                          }}
                          // icon={'user-minus'}
                        >
                          <FiTrash2
                            style={{ fontSize: "14px", marginBottom: "-3px" }}
                          />
                        </Button>
                      </Tip>
                    ) : (
                      ""
                    )}
                  </div>
                }
                // right={actionBarRight}
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            // leftSidebar={maduleList}
            // showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText="There is no tag here..."
                  emptyImage="/images/Tag-empty.png"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}

Tag.contextTypes = {
  __: PropTypes.func,
};

export default Tag;



// WEBPACK FOOTER //
// src/modules/screens/settings/Tag/components/Tag.js